import { GridColDef } from '@mui/x-data-grid';
import {
    Box,
    TextField,
    Alert,
    InputAdornment,
    Typography,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { atom } from 'jotai';
import React, { useState, useMemo, useEffect } from 'react';
import CommonDataGrid from '../../stateless/CommonDataGrid';
import { useTranslation } from 'react-i18next';


export interface ChoiceGroupDataType {
    storeType: any;
    choiceGroupNameEnglish: string;
    choiceGroupNameArabic: string;
    minimumLimit: number | null;
    maximumLimit: number | null;
    choiceDetails: any;
    choiceGroupOption: any;
    merchantDetails: any;
    id: any;
    storeId?: string;
}

export const choiceGroupAtom = atom<ChoiceGroupDataType | null>(null);

interface ManageChoicesGroupTableProps {
    storeId?: string;
}

const ManageChoiceGroupTable: React.FC<ManageChoicesGroupTableProps> = () => {
    const { t, i18n } = useTranslation();
    const [, forceUpdate] = useState({});

    const [selectedRows, setSelectedRows] = useState<string[]>([]);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const snackbarMessage = ''; // Replace with actual message
    const snackbarSeverity: 'success' | 'error' | 'info' | 'warning' = 'info';


    const [searchTerm, setSearchTerm] = useState('');
    // const debouncedSearch = useDebounce(searchTerm, 400);

    // Force re-render when language changes
    useEffect(() => {
        const handleLanguageChange = () => {
            forceUpdate({});
        };

        i18n.on('languageChanged', handleLanguageChange);

        return () => {
            i18n.off('languageChanged', handleLanguageChange);
        };
    }, [i18n]);

    // const { params, dispatch } = useGroupChoiceParams();
    // const isReady = Boolean(params && Object.keys(params).length > 0);

    // const memoizedParams = useMemo(() => {
    //   return isReady ? params : {};
    // }, [isReady, params]);
    // const { data: ChoiceGroupData, isLoading, refetch} = useAllChoiceGroup(memoizedParams)

    //   const filteredRows = React.useMemo(() => {
    //     if (!ChoiceGroupData?.data) return [];
    //     const storeOwners = ChoiceGroupData?.data || []

    //     return storeOwners.map((row, index) => ({
    //       ...row,
    //        id: row.choiceGroupId,
    //         sno: index + 1 + (Number(params.page - 1)) * Number(params.limit),
    //         name: row.storeName?? 'N/A',
    //         merchantType: row.storeType ?? 'N/A',
    //         ChoiceGroup: row.choiceGroupNameEnglish,
    //         minimumLimit: row.minimumLimit,
    //         maximumLimit: row.maximumLimit,
    //         choiceDetails: row.choiceDetails.map((detail) => detail.choiceId),
    //     }));
    //   }, [params.search, ChoiceGroupData, params.page, params.limit]);

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(e.target.value)
    };

    //   useEffect(() => {
    //     dispatch({ type: 'SET_SEARCH', payload: debouncedSearch ? debouncedSearch : undefined });
    //   }, [debouncedSearch]);

    //   const handlePageChange = (newPage: number) => {
    //     dispatch({ type: 'SET_PAGE', payload: newPage + 1 });
    //   };

    //   const handlePageSizeChange = (newSize: number) => {
    //     dispatch({ type: 'SET_LIMIT', payload: newSize });
    //   };

    // const handleFilterChange = (sortBy: string, sortOrder: 'asc' | 'desc') => {
    //   dispatch({ type: 'SET_SORT', payload: { sortBy, sortOrder } });
    // };




    //   const totalItems = params.search
    //     ? filteredRows.length
    //     : ChoiceGroupData?.pagination?.totalItems || 0

    const columns = useMemo<GridColDef[]>(() => [
        {
            field: 'sno',
            headerName: t('cancellationPayment.columns.sno'),
            flex: 0.3,
        },
        {
            field: 'customerEmail',
            headerName: t('cancellationPayment.columns.customerEmail'),
            flex: 2,
        },
        {
            field: 'orderId',
            headerName: t('cancellationPayment.columns.orderId'),
            flex: 2,
        },
        {
            field: 'cancellationAmount',
            headerName: t('cancellationPayment.columns.cancellationAmount'),
            flex: 1,
        },
        {
            field: 'commission',
            headerName: t('cancellationPayment.columns.commission'),
            flex: 1,
        },
        {
            field: 'payableAmount',
            headerName: t('cancellationPayment.columns.payableAmount'),
            flex: 1,
        },
        {
            field: 'amountPaid',
            headerName: t('cancellationPayment.columns.amountPaid'),
            flex: 1,
        },
        {
            field: 'balanceAmount',
            headerName: t('cancellationPayment.columns.balanceAmount'),
            flex: 1,
        },
    ], [t]);

    // Format the manageStoreData for the DataGrid

    const filteredRows = [
        {
            id: 1,
            sno: 1,
            customerEmail: "john.doe@example.com",
            orderId: "ORD123456789",
            cancellationAmount: 50,
            commission: 10,
            payableAmount: 90,
            amountPaid: 80,
            balanceAmount: 10,
        },
        {
            id: 2,
            sno: 2,
            customerEmail: "jane.smith@example.com",
            orderId: "ORD987654321",
            cancellationAmount: 0,
            commission: 20,
            payableAmount: 180,
            amountPaid: 180,
            balanceAmount: 0,
        },
        {
            id: 3,
            sno: 3,
            customerEmail: "mike.brown@example.com",
            orderId: "ORD112233445",
            cancellationAmount: 30,
            commission: 15,
            payableAmount: 120,
            amountPaid: 100,
            balanceAmount: 20,
        },
        {
            id: 4,
            sno: 4,
            customerEmail: "alice.jones@example.com",
            orderId: "ORD556677889",
            cancellationAmount: 10,
            commission: 5,
            payableAmount: 70,
            amountPaid: 70,
            balanceAmount: 0,
        },
    ];
  const handleRowSelection = (selectionModel: any) => {
    setSelectedRows(selectionModel);
  };


    return (
        <>
            <Typography variant="h5" fontWeight="bold" mb={2}>
                {t('cancellationPayment.title')}
            </Typography>
            <Box
                sx={{
                    p: 2,
                    border: '1px solid #e0e0e0',
                    marginTop: '20px',
                    color: '#666',
                }}
            >
                {snackbarOpen && (
                    <Box sx={{ mb: 2 }}>
                        <Alert
                            severity={snackbarSeverity}
                            onClose={() => setSnackbarOpen(false)}
                        >
                            {snackbarMessage}
                        </Alert>
                    </Box>
                )}
                <Box
                    sx={{
                        // p: 2,
                        mb: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        flexWrap: 'wrap',
                        gap: 2, // Optional: adds spacing between wrapped items
                    }}
                >
                    {/* Search - Left */}
                    <Box
                        sx={{
                            width: 600,
                            border: '1px solid #ccc',
                            borderRadius: '8px',
                            background: '#fff',
                        }}
                    >
                        <TextField
                            fullWidth
                            placeholder={t('cancellationPayment.searchPlaceholder')}
                            size="medium"
                            value={searchTerm}
                            onChange={handleSearchChange}
                            sx={{
                                '.MuiOutlinedInput-root': {
                                    height: 40,
                                    width: 600,
                                    border: 'none', // remove inner border
                                },
                                '& fieldset': {
                                    border: 'none', // remove Material-UI default border
                                },
                                '& .MuiInputBase-input': {
                                    paddingTop: '10px', // adjust this value to move the placeholder lower
                                },
                            }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon
                                            sx={{ fontSize: 20, color: '#aaa', mt: '4px' }}
                                        />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Box>

                    {/* Action Buttons + Add Button - Right */}
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 2,
                            flexWrap: 'wrap',
                        }}
                    >
                    </Box>
                </Box>

                {/* <CommonDataGrid
                      key={`datagrid-page-${params.page}-limit-${params.limit}`}
                    rows={filteredRows || []}
                    columns={columns}
                      pageSize={params.limit}
                      onPageChange={handlePageChange}
                      onPageSizeChange={handlePageSizeChange}
                      checkboxSelection
                      loading={isLoading}
                      page={params.page - 1}
                      rowCount={CMSData?.pagination?.totalItems}
                      components={{
                        NoRowsOverlay: () => <ErrorHandler type="no-data" message="No categories found" onRetry={() => refetch()} />
                      }}
                    onRowSelectionModelChange={(ids: string[]) => setSelectedRows(ids)}
                    selectionModel={selectedRows} pageSize={0} onPageSizeChange={function (): void {
                        throw new Error('Function not implemented.');
                    }} components={undefined} 
                    /> */}
                     <CommonDataGrid
                        rows={filteredRows}
                        columns={columns}
                        pageSize={10}
                        onPageSizeChange={() => { }}
                        loading={false}
                        components={{}}
                        checkboxSelection
                        onRowSelectionModelChange={handleRowSelection}
                        selectionModel={selectedRows}
                      />
            </Box>
        </>
    );
};

export default ManageChoiceGroupTable;

